import { render, staticRenderFns } from "./CommunityBusinessNewsCard.vue?vue&type=template&id=962d9254&scoped=true&"
import script from "./CommunityBusinessNewsCard.vue?vue&type=script&lang=js&"
export * from "./CommunityBusinessNewsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962d9254",
  null
  
)

export default component.exports